// src/utils/statistics.js (Updated)
export class StatisticsCalculator {
  static calculateFiveNumberSummary(marks) {
    const sorted = [...marks].sort((a, b) => a - b);
    const n = sorted.length;
    
    const minimum = sorted[0];
    const maximum = sorted[n - 1];
    const median = this.calculateMedian(sorted);
    const q1 = this.calculateQuartile(sorted, 1);
    const q3 = this.calculateQuartile(sorted, 3);
    const mean = marks.reduce((sum, mark) => sum + mark, 0) / n;
    const standardDeviation = this.calculateStandardDeviation(marks, mean);

    return {
      minimum,
      q1,
      median,
      q3,
      maximum,
      mean,
      standardDeviation
    };
  }

  static calculateMedian(sortedArray) {
    const n = sortedArray.length;
    if (n % 2 === 0) {
      return (sortedArray[n / 2 - 1] + sortedArray[n / 2]) / 2;
    }
    return sortedArray[Math.floor(n / 2)];
  }

  static calculateQuartile(sortedArray, quartile) {
    const n = sortedArray.length;
    const position = quartile === 1 ? (n + 1) / 4 : 3 * (n + 1) / 4;
    
    if (position % 1 === 0) {
      return sortedArray[position - 1];
    }
    
    const lower = Math.floor(position) - 1;
    const upper = Math.ceil(position) - 1;
    const weight = position - Math.floor(position);
    
    return sortedArray[lower] + weight * (sortedArray[upper] - sortedArray[lower]);
  }

  static calculateStandardDeviation(marks, mean) {
    const variance = marks.reduce((sum, mark) => sum + Math.pow(mark - mean, 2), 0) / marks.length;
    return Math.sqrt(variance);
  }

  static calculatePerformanceLevels(marks) {
    const levels = [
      { level: 1, range: '0-29%', description: 'Not Achieved', count: 0, percentage: 0 },
      { level: 2, range: '30-39%', description: 'Partially Achieved', count: 0, percentage: 0 },
      { level: 3, range: '40-49%', description: 'Achieved', count: 0, percentage: 0 },
      { level: 4, range: '50-59%', description: 'Competent', count: 0, percentage: 0 },
      { level: 5, range: '60-69%', description: 'Proficient', count: 0, percentage: 0 },
      { level: 6, range: '70-79%', description: 'Excellent', count: 0, percentage: 0 },
      { level: 7, range: '80-100%', description: 'Outstanding (Distinction)', count: 0, percentage: 0 }
    ];

    marks.forEach(mark => {
      const percentage = mark.percentageMark;
      if (percentage < 30) levels[0].count++;
      else if (percentage < 40) levels[1].count++;
      else if (percentage < 50) levels[2].count++;
      else if (percentage < 60) levels[3].count++;
      else if (percentage < 70) levels[4].count++;
      else if (percentage < 80) levels[5].count++;
      else levels[6].count++;
    });

    const total = marks.length;
    levels.forEach(level => {
      level.percentage = total > 0 ? (level.count / total) * 100 : 0;
    });

    return levels;
  }

  static calculateMarkQuartile(percentage) {
    if (percentage <= 25) return 'Q1';
    if (percentage <= 50) return 'Q2';
    if (percentage <= 75) return 'Q3';
    return 'Q4';
  }

  static calculatePerformanceLevel(percentage) {
    if (percentage < 30) return 'L1';
    if (percentage < 40) return 'L2';
    if (percentage < 50) return 'L3';
    if (percentage < 60) return 'L4';
    if (percentage < 70) return 'L5';
    if (percentage < 80) return 'L6';
    return 'L7';
  }

  static getPerformanceLevelDescription(level) {
    const descriptions = {
      'L1': 'Not Achieved (0-29%)',
      'L2': 'Partially Achieved (30-39%)',
      'L3': 'Achieved (40-49%)',
      'L4': 'Competent (50-59%)',
      'L5': 'Proficient (60-69%)',
      'L6': 'Excellent (70-79%)',
      'L7': 'Distinction (80-100%)'
    };
    return descriptions[level] || level;
  }

  static getPerformanceLevelColor(level) {
    const colors = {
      'L1': 'bg-red-100 text-red-800',
      'L2': 'bg-orange-100 text-orange-800',
      'L3': 'bg-yellow-100 text-yellow-800',
      'L4': 'bg-blue-100 text-blue-800',
      'L5': 'bg-indigo-100 text-indigo-800',
      'L6': 'bg-purple-100 text-purple-800',
      'L7': 'bg-green-100 text-green-800'
    };
    return colors[level] || 'bg-gray-100 text-gray-800';
  }

  static calculateQuestionPerformance(marks) {
    const questionStats = {};

    marks.forEach(learnerMark => {
      learnerMark.questionMarks.forEach(qMark => {
        const key = `${qMark.questionNumber}`;
        if (!questionStats[key]) {
          questionStats[key] = { total: 0, count: 0, marks: [] };
        }
        const percentage = (qMark.achievedMarks / qMark.maxMarks) * 100;
        questionStats[key].total += percentage;
        questionStats[key].count++;
        questionStats[key].marks.push(percentage);
      });
    });

    return Object.entries(questionStats).map(([questionNumber, stats]) => ({
      questionNumber: parseInt(questionNumber),
      averagePercentage: stats.total / stats.count,
      fiveNumberSummary: this.calculateFiveNumberSummary(stats.marks)
    }));
  }
}